module.exports = __webpack_public_path__ + "static/media/express.9af67339.svg";